// extracted by mini-css-extract-plugin
export var carousel = "social-videos-module--carousel--bfa4b";
export var copy = "social-videos-module--copy--3c456";
export var inner = "social-videos-module--inner--bc99d";
export var statsWidget = "social-videos-module--statsWidget--40487";